(function () {
  angular.module('binky.core.common.selection', ['binky.core.lodash']);
})();
